<app-loading></app-loading>
<div class="create-franchise-header pt-4 franchise-styling">
  <div class="container">
    <h1 class="mt-4 text-center">
      {{ "FranchiseDetails.FranchiseQRTitle" | translate }}
    </h1>
  </div>
</div>

<div class="container l-content" style="max-width: 900px;">
  <div class="restrictionsFillter">
    <div class="restrictionsFillter-header">
      
      <!-- بيانات قيد الامتياز -->
      <div class="row d-flex flex-column">
        <div class="restrictionCard-title1">{{ 'QRDetails.franchise_record_details' | translate }}</div>
        <div class="row mt-4">
          
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.franchise_number' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.franchiseNumber }}
            </div>
          </div>
          
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.franchise_status' | translate }}
            <div class="restrictionCard-title2">
              <div
                class="badge"
                [class.badge-success]="
                  qrCodeDetails?.franchiseStatusId ===
                  franchiseStatusEnum.Approved
                "
                [class.badge-danger]="
                  qrCodeDetails?.franchiseStatusId ===
                  franchiseStatusEnum.Canceled
                "
                [class.badge-warning]="
                  qrCodeDetails?.franchiseStatusId ===
                  franchiseStatusEnum.Expired
                "
              >
                {{ qrCodeDetails?.franchiseStatusName }}
              </div>
            </div>
          </div>
          
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.franchise_creation_date' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.franchiseCreationDate }}
            </div>
          </div>
          
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.franchise_start_date' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.franchiseStartDate }}
            </div>
          </div>
          
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.franchise_end_date' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.franchiseEndDate }}
            </div>
          </div>
          
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.franchise_work_description' | translate }}
            <div *ngIf="qrCodeDetails?.franchiseWorkDescription" class="restrictionCard-title2">
              {{ qrCodeDetails?.franchiseWorkDescription }}
            </div>
              <div *ngIf="!qrCodeDetails?.franchiseWorkDescription" class="restrictionCard-title2">
              {{ 'QRDetails.notFound' | translate}}
            </div>
          </div>
          
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.reference_type' | translate }}
            <div *ngIf="qrCodeDetails?.referenceTypeName" class="restrictionCard-title2">
              {{ qrCodeDetails?.referenceTypeName }}
            </div>
            <div *ngIf="!qrCodeDetails?.referenceTypeName" class="restrictionCard-title2">
              {{ 'QRDetails.notFound' | translate}}
            </div>
          </div>
          
          <!-- تظهر البيانات على حسب آلية المنح سجل تجاري -->
          <div
            class="col-12 col-md-6 restrictionCard-label mb-3"
            *ngIf="referenceTypesEnum.CrName === qrCodeDetails?.referenceTypeId"
          >
            {{ 'QRDetails.cr_name' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.donor?.crName }}
            </div>
          </div>
          
          <!-- تظهر البيانات على حسب آلية المنح علامة تجارية -->
          <div
            class="col-12 col-md-6 restrictionCard-label mb-3"
            *ngIf="
              referenceTypesEnum.Trademark === qrCodeDetails?.referenceTypeId
            "
          >
            {{ 'QRDetails.trademark_name_ar' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.tradeMarkNameAr }}
            </div>
          </div>
          
          <div
            class="col-12 col-md-6 restrictionCard-label mb-3"
            *ngIf="
              referenceTypesEnum.Trademark === qrCodeDetails?.referenceTypeId
            "
          >
            {{ 'QRDetails.trademark_name_en' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.tradeMarkNameEn }}
            </div>
          </div>
          
   <div
  class="col-12 col-md-6 restrictionCard-label mb-3 "
  *ngIf="referenceTypesEnum.Trademark === qrCodeDetails?.referenceTypeId"
>
  <div class=" d-flex flex-column align-items-start gap-3">
    <span>{{ 'QRDetails.trademark_logo' | translate }}</span>
    <img  *ngIf="qrCodeDetails?.tradeMarkLogoBase64"
      [src]="'data:image/png;base64,' + qrCodeDetails?.tradeMarkLogoBase64" 
      class="img-fluid" 
      style="max-height: 85px;" 
    />
      <div *ngIf="!qrCodeDetails?.tradeMarkLogoBase64" class="restrictionCard-title2">
              {{ 'QRDetails.notFound' | translate}}
            </div>
  </div>
</div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.franchise_type' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.franchiseTypeName }}
            </div>
          </div>

<ng-container *ngIf="qrCodeDetails?.franchiseTypeId === franchiseTypesEnum.Main">
  <div class="col-12 restrictionCard-label mb-3">
    {{ 'FranchiseDetails.DetailedRegions' | translate }} 
    
    <ng-container *ngIf="qrCodeDetails?.locations && qrCodeDetails.locations.length > 0; else notFoundRegions">
      <div *ngFor="let loc of qrCodeDetails.locations" class="mt-2 p-2 border rounded" style="max-width: 50%;">
        <div class="restrictionCard-title2 font-weight-bold">
          {{ loc.regionName }}
        </div>
        <div class="text-muted" *ngIf="loc?.citiesNames && loc.citiesNames.length > 0">
          {{ loc.citiesNames.join(", ") }}
        </div>
      </div>
    </ng-container>

    <ng-template #notFoundRegions>
      <div class="restrictionCard-title2 mt-2">
        {{ 'QRDetails.notFound' | translate }}
      </div>
    </ng-template>
  </div>
</ng-container>


<ng-container *ngIf="qrCodeDetails?.franchiseTypeId === franchiseTypesEnum.Normal">
  <div class="col-12 col-md-6 restrictionCard-label mb-3">
    {{ 'QRDetails.region' | translate }}
    <div
      class="restrictionCard-title2"
      *ngIf="qrCodeDetails?.locations && qrCodeDetails.locations.length > 0 && qrCodeDetails.locations[0]?.regionName; else notFoundRegion"
    >
      {{ qrCodeDetails.locations[0].regionName }}
    </div>
    <ng-template #notFoundRegion>
      <div class="restrictionCard-title2">
        {{ 'QRDetails.notFound' | translate }}
      </div>
    </ng-template>
  </div>

  <div class="col-12 col-md-6 restrictionCard-label mb-3">
    {{ 'QRDetails.city' | translate }}
    <div
      class="restrictionCard-title2"
      *ngIf="qrCodeDetails?.locations && qrCodeDetails.locations.length > 0 && qrCodeDetails.locations[0]?.citiesNames && qrCodeDetails.locations[0].citiesNames.length > 0; else notFoundCity"
    >
      {{ qrCodeDetails.locations[0].citiesNames.join(", ") }}
    </div>
    <ng-template #notFoundCity>
      <div class="restrictionCard-title2">
        {{ 'QRDetails.notFound' | translate }}
      </div>
    </ng-template>
  </div>

  <div class="col-12 col-md-6 restrictionCard-label mb-3">
    {{ 'QRDetails.district' | translate }}
    <div *ngIf="qrCodeDetails?.districtName" class="restrictionCard-title2">
      {{ qrCodeDetails?.districtName }}
    </div>
    <div *ngIf="!qrCodeDetails?.districtName" class="restrictionCard-title2">
      {{ 'QRDetails.notFound' | translate }}
    </div>
  </div>
</ng-container>
         <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.port_count' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.portCount }}
            </div>
          </div>
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.cr_type' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.crTypeName }}
            </div>
          </div>
        </div>
      </div>

      <!-- بيانات مانح الامتياز -->
      <div class="row d-flex flex-column mt-4">
        <div class="restrictionCard-title1">{{ 'QRDetails.donor_details' | translate }}</div>
        <div class="row mt-4">
          <div class="col-12 col-md-6 restrictionCard-label mb-3" [hidden]="qrCodeDetails?.crTypeId === crTypesEnum.External">
            {{ 'QRDetails.facility_name' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.donor?.crName }}
            </div>
          </div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3" [hidden]="qrCodeDetails?.crTypeId === crTypesEnum.External">
            {{ 'QRDetails.unified_national_number' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.donor?.crNumber }}
            </div>
          </div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3" [hidden]="qrCodeDetails?.crTypeId === crTypesEnum.External">
            {{ 'QRDetails.record_status' | translate }}
            <div *ngIf="qrCodeDetails?.donor?.crStatus" class="restrictionCard-title2">
              {{ qrCodeDetails?.donor?.crStatus }}
            </div>
             <div *ngIf="!qrCodeDetails?.donor?.crStatus" class="restrictionCard-title2">
              {{ 'QRDetails.notFound' | translate}}
            </div>
          </div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3" [hidden]="qrCodeDetails?.crTypeId === crTypesEnum.Internal">
            {{ 'QRDetails.facility_name' | translate }}
            <div class="restrictionCard-inline restrictionCard-title2">
              {{ qrCodeDetails?.donor?.crName }}
            </div>
          </div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3" [hidden]="qrCodeDetails?.crTypeId === crTypesEnum.Internal">
            {{ 'QRDetails.commercial_record_number' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.donor?.crNumber }}
            </div>
          </div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3" [hidden]="qrCodeDetails?.crTypeId === crTypesEnum.Internal">
            {{ 'QRDetails.record_country' | translate }}
            <div *ngIf="qrCodeDetails?.countryName" class="restrictionCard-title2">
              {{ qrCodeDetails?.countryName }}
            </div>
            <div *ngIf="!qrCodeDetails?.countryName" class="restrictionCard-title2">
             {{ 'QRDetails.notFound' | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- بيانات صاحب الامتياز -->
      <div class="row d-flex flex-column mt-4">
        <div class="restrictionCard-title1">{{ 'QRDetails.owner_details' | translate }}</div>
        <div class="row mt-4">
          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.facility_name' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.owner?.crName }}
            </div>
          </div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.unified_national_number' | translate }}
            <div class="restrictionCard-title2">
              {{ qrCodeDetails?.owner?.crNumber }}
            </div>
          </div>

          <div class="col-12 col-md-6 restrictionCard-label mb-3">
            {{ 'QRDetails.record_status' | translate }}
            <div *ngIf="qrCodeDetails?.owner?.crStatus " class="restrictionCard-title2">
              {{ qrCodeDetails?.owner?.crStatus }}
            </div>
             <div *ngIf="!qrCodeDetails?.owner?.crStatus " class="restrictionCard-title2">
              {{ 'QRDetails.notFound' | translate}}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>